/// HOOKS ///
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
/// ROUTER ///
import { Location } from "react-router-dom";
/// MUI COMPONENTS ///
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import { List } from "@mui/material";
import { ListItemButton } from "@mui/material";
/// FA ///
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
/// ICONS ///
import { faGrip } from "@fortawesome/free-solid-svg-icons";
import { faBuilding } from "@fortawesome/free-solid-svg-icons";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { faClipboardCheck } from "@fortawesome/free-solid-svg-icons";
import { faList } from "@fortawesome/free-solid-svg-icons";
import { faSheetPlastic } from "@fortawesome/free-solid-svg-icons";
import { faShop } from "@fortawesome/free-solid-svg-icons";
/// URLS ///
import { event_url } from "components/navigation/endpoints";
import { market_url } from "components/navigation/endpoints";
import { home_url } from "components/navigation/endpoints";
import { material_url } from "components/navigation/endpoints";
import { org_url } from "components/navigation/endpoints";
import { price_list_url } from "components/navigation/endpoints";
import { shops_url } from "components/navigation/endpoints";
import { wo_url } from "components/navigation/endpoints";
import { week_url } from "components/navigation/endpoints";
/// STYLES ///
import { mini_btn_style } from "styles/drawer";
import { mini_ico_style } from "styles/drawer";

export default function MiniMarketDrawer() {
  const navigate = useNavigate();
  const location: Location<any> = useLocation();

  return (
    <List>
      <ListItemButton key="Dashboard" sx={mini_btn_style(location.pathname === home_url)} onClick={() => navigate(home_url)}>
        <Tooltip title="Dashboard" placement="right">
          <FontAwesomeIcon icon={faGrip} style={mini_ico_style(location.pathname === home_url)} />
        </Tooltip>
      </ListItemButton>
      <ListItemButton key="WO" sx={mini_btn_style(location.pathname.includes(wo_url))} onClick={() => navigate(wo_url)}>
        <Tooltip title="Work Orders" placement="right">
          <FontAwesomeIcon icon={faClipboardCheck} style={mini_ico_style(location.pathname.includes(wo_url))} />
        </Tooltip>
      </ListItemButton>
      <ListItemButton key="Calendar" sx={mini_btn_style(location.pathname.includes(event_url))} onClick={() => navigate(`/${event_url}/${week_url}`)}>
        <Tooltip title="Calendar" placement="right">
          <FontAwesomeIcon icon={faCalendar} style={mini_ico_style(location.pathname.includes(event_url))} />
        </Tooltip>
      </ListItemButton>
      <Divider sx={{ marginBottom: "2px", marginTop: "2px" }} />
      <ListItemButton key="FabPl" sx={mini_btn_style(location.pathname.includes(price_list_url))} onClick={() => navigate(`/${market_url}/${price_list_url}`)}>
        <Tooltip title="Prices" placement="right">
          <FontAwesomeIcon icon={faList} style={mini_ico_style(location.pathname.includes(price_list_url))} />
        </Tooltip>
      </ListItemButton>
      <ListItemButton key="Material" sx={mini_btn_style(location.pathname.includes(material_url))} onClick={() => navigate(`/${market_url}/${material_url}`)}>
        <Tooltip title="Material" placement="right">
          <FontAwesomeIcon icon={faSheetPlastic} style={mini_ico_style(location.pathname.includes(material_url))} />
        </Tooltip>
      </ListItemButton>
      <Divider sx={{ marginBottom: "2px", marginTop: "2px" }} />
      <ListItemButton key="Org" sx={mini_btn_style(location.pathname.includes(org_url))} onClick={() => navigate(`/${org_url}`)}>
        <Tooltip title="Organization" placement="right">
          <FontAwesomeIcon icon={faBuilding} style={mini_ico_style(location.pathname.includes(org_url))} />
        </Tooltip>
      </ListItemButton>
      <ListItemButton key="Shops" sx={mini_btn_style(location.pathname.includes(shops_url))} onClick={() => navigate(`/${shops_url}`)}>
        <Tooltip title="Shops" placement="right">
          <FontAwesomeIcon icon={faShop} style={mini_ico_style(location.pathname.includes(shops_url))} />
        </Tooltip>
      </ListItemButton>
    </List>
  );
}
